// extracted by mini-css-extract-plugin
export var blue = "_36-f";
export var brand = "_36-b";
export var darkGrey = "_36-e";
export var disabled = "_36-4";
export var disabledSubtle = "_36-5";
export var error = "_36-6";
export var green = "_36-g";
export var grey = "_36-d";
export var icon = "_36-0";
export var inherit = "_36-a";
export var lightGrey = "_36-c";
export var orange = "_36-i";
export var pink = "_36-k";
export var primary = "_36-1";
export var purple = "_36-l";
export var red = "_36-j";
export var secondary = "_36-2";
export var success = "_36-9";
export var tertiary = "_36-3";
export var warning = "_36-7";
export var warningSecondary = "_36-8";
export var white = "_36-m";
export var yellow = "_36-h";